import { useContext, useEffect, useRef, useState } from "react";
import BlueButton from "../Common/BlueButton";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import toast from "react-hot-toast";
import { BASE_URL } from "../../config/api";
import axios from "axios";

export default function SuccessSummary({ form }) {
  const navigate = useNavigate();
  console.log("form data:", form);
  const { login } = useContext(AuthContext);

  const [showMpinPopup, setShowMpinPopup] = useState(false);
  const authUserString = localStorage.getItem("authUserData");
  let authUser = authUserString ? JSON.parse(authUserString) : null;

  const role = Number(authUser?.role);
  const isRetailer = role === 5 || role === 6;
  const [isMobile, setIsMobile] = useState(window.innerWidth < 640);
  const isRetailerMobile = isRetailer && isMobile;



const [showMpinSetupPopup, setShowMpinSetupPopup] = useState(false);

const [newMpin, setNewMpin] = useState(["", "", "", ""]);
const [confirmMpin, setConfirmMpin] = useState(["", "", "", ""]);

const newRefs = useRef([]);
const confirmRefs = useRef([]);

const isMpinActive =
  Number(authUser?.is_mpin_active) === 1;

  const handleGoToDashboard = () => {
  const authUserString = localStorage.getItem("authUserData");
  let authUser = authUserString ? JSON.parse(authUserString) : null;



  if (!authUser) return;

  const updatedUser = {
    ...authUser,
    is_verified: 7,
  };

  // ✅ Update context
  login(updatedUser);

  // ✅ Update localStorage
  localStorage.setItem("authUserData", JSON.stringify(updatedUser));

  // Navigate by role
  switch (updatedUser.role) {
    case 5: navigate("/retailerdashboard"); break;
    case 4: navigate("/agentdashboard"); break;
    case 6: navigate("/userdashboard"); break;
    case 3: navigate("/empdashboard"); break;
    case 2: navigate("/admindashboard"); break;
    default: navigate("/");
  }
};

useEffect(() => {
  const justLoggedIn =
    localStorage.getItem("just_logged_in") === "true";

  if (
    justLoggedIn &&
    authUser &&
    Number(authUser?.is_verified) === 7 &&
    (
      authUser?.is_mpin_active === null ||
      Number(authUser?.is_mpin_active) === 0
    )
  ) {
    setShowMpinPopup(true);

    localStorage.removeItem("just_logged_in");
  }
}, [authUser]);


  const handleSetMpin = () => {
  setShowMpinPopup(false);
  setShowMpinSetupPopup(true);
};
const handleBoxChange = (e, index, type = "new") => {
  const value = e.target.value.replace(/\D/g, "");

  const updated =
    type === "new" ? [...newMpin] : [...confirmMpin];

  if (!value) {
    updated[index] = "";

    type === "new"
      ? setNewMpin(updated)
      : setConfirmMpin(updated);

    return;
  }

  updated[index] = value[0];

  type === "new"
    ? setNewMpin(updated)
    : setConfirmMpin(updated);

  if (index < 3) {
    const nextRef =
      type === "new"
        ? newRefs.current[index + 1]
        : confirmRefs.current[index + 1];

    nextRef?.focus();
  }
};

const handleKeyDown = (e, index, type = "new") => {
  if (e.key === "Backspace") {
    const updated =
      type === "new" ? [...newMpin] : [...confirmMpin];

    if (updated[index]) {
      updated[index] = "";
    } else if (index > 0) {
      const prevRef =
        type === "new"
          ? newRefs.current[index - 1]
          : confirmRefs.current[index - 1];

      prevRef?.focus();
    }

    type === "new"
      ? setNewMpin(updated)
      : setConfirmMpin(updated);
  }
};

const handleSubmitMpin = async () => {
  const mpinValue = newMpin.join("");
  const confirmValue = confirmMpin.join("");

  if (mpinValue.length !== 4)
    return toast.error("Enter 4 digit MPIN");

  if (mpinValue !== confirmValue)
    return toast.error("MPIN does not match");

  try {
    const endpoint = isMpinActive
      ? `${BASE_URL}common/update-mpin`
      : `${BASE_URL}common/set-mpin`;

    await axios.post(endpoint, {
      company_id: authUser.id,
      m_pin: mpinValue,
    });

    toast.success(
      isMpinActive ? "MPIN updated" : "MPIN set successfully"
    );

    // ✅ Update local storage first
    const updatedUser = {
      ...authUser,
      is_mpin_active: 1,
    };

    localStorage.setItem(
      "authUserData",
      JSON.stringify(updatedUser)
    );

    localStorage.setItem("isMpinActive", "1");

    // ✅ trigger storage sync 
    window.dispatchEvent(new Event("storage"));

    // reset fields
    setNewMpin(["", "", "", ""]);
    setConfirmMpin(["", "", "", ""]);

    // ✅ reload after update
    handleGoToDashboard()

  } catch (err) {
    toast.error("Failed to update MPIN");
  }
};

  return (
    <div className="mt-4">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center">
          <span className="text-green-600 text-xl">✓</span>
        </div>
        <div>
          <h2 className="text-lg font-semibold text-slate-900">
            All done, onboarding completed!
          </h2>
          <p className="text-sm text-slate-500">
            Your GST and bank details are submitted successfully.
          </p>
        </div>
      </div>

      <div className="grid gap-4 md:grid-cols-2">
        {/* GST Details */}
        <div className="bg-slate-50 rounded-xl p-4">
          <h3 className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-2">
            GST Details
          </h3>
          <p className="text-sm text-slate-700">
            <span className="font-medium">Treatment: </span>
            {form.gstTreatment || "-"}
          </p>
          <p className="text-sm text-slate-700 break-all">
            <span className="font-medium">GSTIN / PAN: </span>
            {form.gstin || "-"}
          </p>
          <p className="text-sm text-slate-700">
            <span className="font-medium">Legal Name: </span>
            {form.businessName || "-"}
          </p>
          <p className="text-sm text-slate-700">
            <span className="font-medium">Trade Name: </span>
            {form.tradeName || "-"}
          </p>
        </div>

        {/* Bank Details */}
        <div className="bg-slate-50 rounded-xl p-4">
          <h3 className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-2">
            Bank Details
          </h3>
          <p className="text-sm text-slate-700 break-all">
            <span className="font-medium">Account: </span>
            {form.accountNumber || "-"}
          </p>
          <p className="text-sm text-slate-700 break-all">
            <span className="font-medium">IFSC: </span>
            {form.ifsc || "-"}
          </p>
          <p className="text-sm text-slate-700">
            <span className="font-medium">Bank: </span>
            {form.bankName || "-"}
          </p>
          <p className="text-sm text-slate-700">
            <span className="font-medium">Authorised: </span>
            {form.authorisedName || "-"}
          </p>
        </div>

        {/* Go to Dashboard Button */}
        <div>
          <BlueButton
            onClick={handleGoToDashboard}
            className="flex items-center justify-center gap-1 px-3 py-1.5 rounded-lg bg-blue-600 text-white hover:bg-blue-700 w-full sm:w-auto"
          >
            Go TO Dashboard
          </BlueButton>
        </div>


      </div>

      {showMpinPopup && (
        <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
          
          <div
            className={`w-full max-w-sm rounded-[32px] p-6 text-center shadow-2xl border ${
              isRetailerMobile
                ? "bg-white/20 backdrop-blur-3xl border-white/20 text-white"
                : "bg-white border-slate-200 text-slate-900"
            }`}
          >
            
            {/* ICON */}
            <div
              className={`w-20 h-20 mx-auto rounded-full flex items-center justify-center text-4xl shadow-lg ${
                isRetailerMobile
                  ? "bg-white/20 backdrop-blur-xl border border-white/20"
                  : "bg-blue-100"
              }`}
            >
              🔐
            </div>

            {/* TITLE */}
            <h2
              className={`mt-5 text-2xl font-bold ${
                isRetailerMobile ? "text-white" : "text-slate-800"
              }`}
            >
              Set Your MPIN
            </h2>

            {/* DESCRIPTION */}
            <p
              className={`mt-3 text-sm leading-6 ${
                isRetailerMobile ? "text-slate-200" : "text-slate-500"
              }`}
            >
              For better security and quick login access,
              would you like to set your MPIN now?
            </p>

            {/* BUTTONS */}
            <div className="mt-7 flex gap-3">
              
              <button
                onClick={() => setShowMpinPopup(false)}
                className={`flex-1 rounded-2xl py-3 font-semibold transition-all ${
                  isRetailerMobile
                    ? "bg-white/10 border border-white/20 text-white hover:bg-white/20"
                    : "border border-slate-300 text-slate-600 hover:bg-slate-100"
                }`}
              >
                Later
              </button>

              <button
                onClick={handleSetMpin}
                className={`flex-1 rounded-2xl py-3 font-semibold transition-all ${
                  isRetailerMobile
                    ? "bg-gradient-to-br from-blue-500 to-indigo-600 text-white shadow-[0_10px_30px_rgba(59,130,246,0.45)]"
                    : "bg-blue-600 text-white hover:bg-blue-700"
                }`}
              >
                Yes
              </button>

            </div>
          </div>
        </div>
      )}

      {showMpinSetupPopup && (
  <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
    <div
      className={`w-full max-w-md rounded-[32px] p-6 shadow-2xl ${
        isRetailerMobile
          ? "bg-white/20 backdrop-blur-3xl border border-white/20"
          : "bg-white"
      }`}
    >
      <div className="text-center mb-6">
        <div
          className={`w-16 h-16 mx-auto rounded-full flex items-center justify-center text-3xl ${
            isRetailerMobile
              ? "bg-white/20"
              : "bg-blue-100"
          }`}
        >
          🔐
        </div>

        <h2
          className={`mt-4 text-xl font-bold ${
            isRetailerMobile
              ? "text-white"
              : "text-slate-900"
          }`}
        >
          Set Your MPIN
        </h2>

        <p
          className={`mt-2 text-sm ${
            isRetailerMobile
              ? "text-slate-200"
              : "text-slate-500"
          }`}
        >
          Create a secure 4-digit MPIN for quick login.
        </p>
      </div>

      <div className="space-y-6 text-center">

        {/* STATUS */}
        <div className="flex items-center justify-between gap-2">
          <span
            className={
              isRetailerMobile
                ? "text-white text-sm font-semibold"
                : "text-sm font-semibold"
            }
          >
            Status:
          </span>

          <span
            className={`px-3 py-1 rounded-full text-xs font-semibold ${
              isMpinActive
                ? "bg-green-100 text-green-700"
                : "bg-gray-100 text-gray-600"
            }`}
          >
            {isMpinActive ? "Active" : "Not Set"}
          </span>
        </div>

        {/* NEW MPIN */}
        <div>
          <label
            className={`text-[12px] block mb-3 ${
              isRetailerMobile
                ? "text-slate-200"
                : "text-slate-500"
            }`}
          >
            Set MPIN
          </label>

          <div className="flex justify-center gap-3">
            {newMpin.map((digit, index) => (
              <input
                key={index}
                ref={(el) => (newRefs.current[index] = el)}
                type="tel"
                inputMode="numeric"
                maxLength={1}
                value={digit}
                onChange={(e) =>
                  handleBoxChange(e, index, "new")
                }
                onKeyDown={(e) =>
                  handleKeyDown(e, index, "new")
                }
                className={`w-14 h-14 rounded-xl border text-center text-xl font-bold ${
                  isRetailerMobile
                    ? "bg-white text-black border-white"
                    : "bg-white border-slate-300 text-slate-800"
                }`}
              />
            ))}
          </div>
        </div>

        {/* CONFIRM MPIN */}
        <div>
          <label
            className={`text-[12px] block mb-3 ${
              isRetailerMobile
                ? "text-slate-200"
                : "text-slate-500"
            }`}
          >
            Confirm MPIN
          </label>

          <div className="flex justify-center gap-3">
            {confirmMpin.map((digit, index) => (
              <input
                key={index}
                ref={(el) =>
                  (confirmRefs.current[index] = el)
                }
                type="tel"
                inputMode="numeric"
                maxLength={1}
                value={digit}
                onChange={(e) =>
                  handleBoxChange(e, index, "confirm")
                }
                onKeyDown={(e) =>
                  handleKeyDown(e, index, "confirm")
                }
                className={`w-14 h-14 rounded-xl border text-center text-xl font-bold ${
                  isRetailerMobile
                    ? "bg-white text-black border-white"
                    : "bg-white border-slate-300 text-slate-800"
                }`}
              />
            ))}
          </div>
        </div>

        <button
          onClick={handleSubmitMpin}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-xl font-semibold"
        >
          Set MPIN
        </button>
      </div>
    </div>
  </div>
)}
    </div>
  );
}

// import { useContext } from "react";
// import BlueButton from "../Common/BlueButton";
// import { useNavigate } from "react-router-dom";
// import { AuthContext } from "../../context/AuthContext";

// export default function SuccessSummary({ form }) {
//   const navigate = useNavigate();
//   console.log("form data:", form);
//   const { login } = useContext(AuthContext);

//   const handleGoToDashboard = () => {
//   const authUserString = localStorage.getItem("authUserData");
//   let authUser = authUserString ? JSON.parse(authUserString) : null;

//   if (!authUser) return;

//   const updatedUser = {
//     ...authUser,
//     is_verified: 7,
//   };

//   // ✅ Update context
//   login(updatedUser);

//   // ✅ Update localStorage
//   localStorage.setItem("authUserData", JSON.stringify(updatedUser));

//   // Navigate by role
//   switch (updatedUser.role) {
//     case 5: navigate("/retailerdashboard"); break;
//     case 4: navigate("/agentdashboard"); break;
//     case 6: navigate("/userdashboard"); break;
//     case 3: navigate("/empdashboard"); break;
//     case 2: navigate("/admindashboard"); break;
//     default: navigate("/");
//   }
// };



//   return (
//     <div className="mt-4">
//       <div className="flex items-center gap-3 mb-4">
//         <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center">
//           <span className="text-green-600 text-xl">✓</span>
//         </div>
//         <div>
//           <h2 className="text-lg font-semibold text-slate-900">
//             All done, onboarding completed!
//           </h2>
//           <p className="text-sm text-slate-500">
//             Your GST and bank details are submitted successfully.
//           </p>
//         </div>
//       </div>

//       <div className="grid gap-4 md:grid-cols-2">
//         {/* GST Details */}
//         <div className="bg-slate-50 rounded-xl p-4">
//           <h3 className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-2">
//             GST Details
//           </h3>
//           <p className="text-sm text-slate-700">
//             <span className="font-medium">Treatment: </span>
//             {form.gstTreatment || "-"}
//           </p>
//           <p className="text-sm text-slate-700 break-all">
//             <span className="font-medium">GSTIN / PAN: </span>
//             {form.gstin || "-"}
//           </p>
//           <p className="text-sm text-slate-700">
//             <span className="font-medium">Legal Name: </span>
//             {form.businessName || "-"}
//           </p>
//           <p className="text-sm text-slate-700">
//             <span className="font-medium">Trade Name: </span>
//             {form.tradeName || "-"}
//           </p>
//         </div>

//         {/* Bank Details */}
//         <div className="bg-slate-50 rounded-xl p-4">
//           <h3 className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-2">
//             Bank Details
//           </h3>
//           <p className="text-sm text-slate-700 break-all">
//             <span className="font-medium">Account: </span>
//             {form.accountNumber || "-"}
//           </p>
//           <p className="text-sm text-slate-700 break-all">
//             <span className="font-medium">IFSC: </span>
//             {form.ifsc || "-"}
//           </p>
//           <p className="text-sm text-slate-700">
//             <span className="font-medium">Bank: </span>
//             {form.bankName || "-"}
//           </p>
//           <p className="text-sm text-slate-700">
//             <span className="font-medium">Authorised: </span>
//             {form.authorisedName || "-"}
//           </p>
//         </div>

//         {/* Go to Dashboard Button */}
//         <div>
//           <BlueButton
//             onClick={handleGoToDashboard}
//             className="flex items-center justify-center gap-1 px-3 py-1.5 rounded-lg bg-blue-600 text-white hover:bg-blue-700 w-full sm:w-auto"
//           >
//             Go TO Dashboard
//           </BlueButton>
//         </div>
//       </div>
//     </div>
//   );
// }



// import BlueButton from "../Common/BlueButton";
// import { useNavigate } from "react-router-dom";

// export default function SuccessSummary({ form }) {
//   const navigate = useNavigate();
//   console.log("form data:")

//   const handleGoToDashboard = () => {

//     // **Save onboarding completed status**
//     localStorage.setItem("onboard_completed", "true");

//     const authUserString = localStorage.getItem("authUserData");
//     const authUser = authUserString ? JSON.parse(authUserString) : null;
//     const type = authUser?.type; // use 'type' instead of 'role'

//     switch (type) {
//       case "retailer":
//         navigate("/retailerdashboard");
//         break;
//       case "agent":
//         navigate("/agentdashboard");
//         break;
//       case "retailer_user":
//         navigate("/userdashboard");
//         break;
//       case "employee":
//         navigate("/empdashboard");
//         break;
//       case "company":
//         navigate("/admindashboard");
//         break;
//       default:
//         navigate("/"); // fallback
//     }
//   };

//   return (
//     <div className="mt-4">
//       <div className="flex items-center gap-3 mb-4">
//         <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center">
//           <span className="text-green-600 text-xl">✓</span>
//         </div>
//         <div>
//           <h2 className="text-lg font-semibold text-slate-900">
//             All done, onboarding completed!
//           </h2>
//           <p className="text-sm text-slate-500">
//             Your GST and bank details are submitted successfully.
//           </p>
//         </div>
//       </div>

//       <div className="grid gap-4 md:grid-cols-2">
//         <div className="bg-slate-50 rounded-xl p-4">
//           <h3 className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-2">
//             GST Details
//           </h3>
//           <p className="text-sm text-slate-700">
//             <span className="font-medium">Treatment: </span>
//             {form.gstTreatment || "-"}
//           </p>
//           <p className="text-sm text-slate-700 break-all">
//             <span className="font-medium">GSTIN / PAN: </span>
//             {form.gstin || "-"}
//           </p>
//           <p className="text-sm text-slate-700">
//             <span className="font-medium">Legal Name: </span>
//             {form.businessName || "-"}
//           </p>
//           <p className="text-sm text-slate-700">
//             <span className="font-medium">Trade Name: </span>
//             {form.tradeName || "-"}
//           </p>
//         </div>

//         <div className="bg-slate-50 rounded-xl p-4">
//           <h3 className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-2">
//             Bank Details
//           </h3>
//           <p className="text-sm text-slate-700 break-all">
//             <span className="font-medium">Account: </span>
//             {form.accountNumber || "-"}
//           </p>
//           <p className="text-sm text-slate-700 break-all">
//             <span className="font-medium">IFSC: </span>
//             {form.ifsc || "-"}
//           </p>
//           <p className="text-sm text-slate-700">
//             <span className="font-medium">Bank: </span>
//             {form.bankName || "-"}
//           </p>
//           <p className="text-sm text-slate-700">
//             <span className="font-medium">Authorised: </span>
//             {form.authorisedName || "-"}
//           </p>
//         </div>

//         <div>
//           <BlueButton
//             onClick={handleGoToDashboard}
//             className="flex items-center justify-center gap-1 px-3 py-1.5 rounded-lg bg-blue-600 text-white hover:bg-blue-700 w-full sm:w-auto"
//           >
//             Go TO Dashboard
//           </BlueButton>
//         </div>
//       </div>
//     </div>
//   );
// }



// import BlueButton from "../Common/BlueButton";
// import { useNavigate } from "react-router-dom";

// export default function SuccessSummary({ form }) {
//   const navigate = useNavigate();

//   const handleGoToDashboard = () => {
//     const authUserString = localStorage.getItem("authUserData");
//     const authUser = authUserString ? JSON.parse(authUserString) : null;
//     const type = authUser?.type; // use 'type' instead of 'role'

//     switch (type) {
//       case "retailer":
//         navigate("/retailerdashboard");
//         break;
//       case "agent":
//         navigate("/agentdashboard");
//         break;
//       case "retailer_user":
//         navigate("/userdashboard");
//         break;
//       case "employee":
//         navigate("/empdashboard");
//         break;
//       case "company":
//         navigate("/admindashboard");
//         break;
//       default:
//         navigate("/"); // fallback
//     }
//   };


//   return (
//     <div className="mt-4">
//       <div className="flex items-center gap-3 mb-4">
//         <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center">
//           <span className="text-green-600 text-xl">✓</span>
//         </div>
//         <div>
//           <h2 className="text-lg font-semibold text-slate-900">
//             All done, onboarding completed!
//           </h2>
//           <p className="text-sm text-slate-500">
//             Your GST and bank details are submitted successfully.
//           </p>
//         </div>
//       </div>

//       <div className="grid gap-4 md:grid-cols-2">
//         <div className="bg-slate-50 rounded-xl p-4">
//           <h3 className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-2">
//             GST Details
//           </h3>
//           <p className="text-sm text-slate-700">
//             <span className="font-medium">Treatment: </span>
//             {form.gstTreatment || "-"}
//           </p>
//           <p className="text-sm text-slate-700 break-all">
//             <span className="font-medium">GSTIN / PAN: </span>
//             {form.gstin || "-"}
//           </p>
//           <p className="text-sm text-slate-700">
//             <span className="font-medium">Legal Name: </span>
//             {form.businessName || "-"}
//           </p>
//           <p className="text-sm text-slate-700">
//             <span className="font-medium">Trade Name: </span>
//             {form.tradeName || "-"}
//           </p>
//         </div>

//         <div className="bg-slate-50 rounded-xl p-4">
//           <h3 className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-2">
//             Bank Details
//           </h3>
//           <p className="text-sm text-slate-700 break-all">
//             <span className="font-medium">Account: </span>
//             {form.accountNumber || "-"}
//           </p>
//           <p className="text-sm text-slate-700 break-all">
//             <span className="font-medium">IFSC: </span>
//             {form.ifsc || "-"}
//           </p>
//           <p className="text-sm text-slate-700">
//             <span className="font-medium">Bank: </span>
//             {form.bankName || "-"}
//           </p>
//           <p className="text-sm text-slate-700">
//             <span className="font-medium">Authorised: </span>
//             {form.authorisedName || "-"}
//           </p>
//         </div>

//         <div>
//           <BlueButton
//             onClick={handleGoToDashboard}
//             className="flex items-center justify-center gap-1 px-3 py-1.5 rounded-lg bg-blue-600 text-white hover:bg-blue-700 w-full sm:w-auto"
//           >
//             Go TO Dashboard
//           </BlueButton>
//         </div>
//       </div>
//     </div>
//   );
// }


// import BlueButton from "../Common/BlueButton";

// export default function SuccessSummary({ form }) {
//   return (
//     <div className="mt-4">
//       <div className="flex items-center gap-3 mb-4">
//         <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center">
//           <span className="text-green-600 text-xl">✓</span>
//         </div>
//         <div>
//           <h2 className="text-lg font-semibold text-slate-900">
//             All done, onboarding completed!
//           </h2>
//           <p className="text-sm text-slate-500">
//             Your GST and bank details are submitted successfully.
//           </p>
//         </div>
//       </div>

//       <div className="grid gap-4 md:grid-cols-2">
//         <div className="bg-slate-50 rounded-xl p-4">
//           <h3 className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-2">
//             GST Details
//           </h3>
//           <p className="text-sm text-slate-700">
//             <span className="font-medium">Treatment: </span>
//             {form.gstTreatment || "-"}
//           </p>
//           <p className="text-sm text-slate-700 break-all">
//             <span className="font-medium">GSTIN / PAN: </span>
//             {form.gstin || "-"}
//           </p>
//           <p className="text-sm text-slate-700">
//             <span className="font-medium">Legal Name: </span>
//             {form.businessName || "-"}
//           </p>
//           <p className="text-sm text-slate-700">
//             <span className="font-medium">Trade Name: </span>
//             {form.tradeName || "-"}
//           </p>
//         </div>

//         <div className="bg-slate-50 rounded-xl p-4">
//           <h3 className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-2">
//             Bank Details
//           </h3>
//           <p className="text-sm text-slate-700 break-all">
//             <span className="font-medium">Account: </span>
//             {form.accountNumber || "-"}
//           </p>
//           <p className="text-sm text-slate-700 break-all">
//             <span className="font-medium">IFSC: </span>
//             {form.ifsc || "-"}
//           </p>
//           <p className="text-sm text-slate-700">
//             <span className="font-medium">Bank: </span>
//             {form.bankName || "-"}
//           </p>
//           <p className="text-sm text-slate-700">
//             <span className="font-medium">Authorised: </span>
//             {form.authorisedName || "-"}
//           </p>
//         </div>
//         <div>
//           <BlueButton
          
//           className="flex items-center justify-center gap-1 px-3 py-1.5 rounded-lg bg-blue-600 text-white hover:bg-blue-700 w-full sm:w-auto"
//           >
//             Go TO Dashboard
//           </BlueButton>
//         </div>
//       </div>
//     </div>
//   );
// }